import React, { useState } from "react";
import {
  doc,
  updateDoc,
  arrayUnion,
  deleteDoc,
  Timestamp
} from "firebase/firestore";
import { firestore } from "../../helpers/firebaseConfig";

const tagStyles = {
  validated: { background: "#22c55e", color: "#fff" },    // green-500
  commented:  { background: "#ef4444", color: "#fff" }     // red-500
};

function TicketBlock({ ticket, onSelect }) {
  const [collapsed, setCollapsed] = useState(false);
  const [showAdd, setShowAdd]     = useState(false);
  const [newComment, setNewComment] = useState("");

  const address = ticket.address || "";


  const saveComment = async () => {
    if (!newComment.trim()) return;
    await updateDoc(
      doc(
        firestore,
        "simulations",
        ticket.simulationId,
        "model_tickets",
        ticket.id
      ),
      {
        comments_array: arrayUnion({
          text: newComment.trim(),
          ts:   Timestamp.now().toMillis()
        }),
        status: "commented"
      }
    );
    setNewComment("");
    setShowAdd(false);
  };

  const removeTicket = async () => {
    await deleteDoc(
      doc(
        firestore,
        "simulations",
        ticket.simulationId,
        "model_tickets",
        ticket.id
      )
    );
  };

  return (
    <div
      style={{
        background: "#2C2C2C",
        border: "1px solid #333",
        borderRadius: 8,
        padding: 12,
        marginBottom: 12,
        color: "#ddd",
        cursor: 'pointer'
      }}
      onClick={() => onSelect(ticket)}
    >
      {/* header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>

        <div onClick={() => setCollapsed(!collapsed)} style={{ cursor: "pointer" }}>
            <strong>{address}</strong>
           
        </div>
 

        <div style={{ display: "flex", gap: 8 }}>
          <span
            style={{
              ...tagStyles[ticket.status] || {},
              padding: "6px 6px",
              borderRadius: 4,
              fontSize: 12
            }}
          >
            {ticket.status}
          </span>
          
          <button
            onClick={removeTicket}
            title="Delete ticket"
            style={{
              border: "none",
              background: "#2C2C2C",
              color: "#fff",
              borderRadius: 4,
              cursor: "pointer",
              padding: "2px 8px"
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" height="20" width="20" viewBox="0 0 20 20">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-4.5l-1-1z"/>
            </svg>
          </button>
        </div>
      </div>

       {/* 3️⃣  show link / parcel address just under the id */}
       {address && (
            <div style={{ fontSize: 12, color: "#9CA3AF" }}>{ticket.id}</div>
        )}

      {!collapsed && (
        <>
          {/* comments list */}
          <div style={{ marginTop: 10 }}>
            {ticket.comments_array && ticket.comments_array.length ? (
              ticket.comments_array.map((c, i) => (
                <div
                  key={i}
                  style={{
                    background: "#2A2A2A",
                    padding: "6px 8px",
                    borderRadius: 4,
                    marginBottom: 6,
                    fontSize: 16
                  }}
                >
                  {c.text}
                </div>
              ))
            ) : (
              <em style={{ color: "#888" }}>No comments yet.</em>
            )}
          </div>

          {/* add-comment UI */}
          {showAdd ? (
            <div style={{ marginTop: 8 }}>
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                rows={2}
                style={{
                  width: "100%",
                  borderRadius: 4,
                  background: "#2A2A2A",
                  color: "#fff",
                  border: "1px solid #555",
                  padding: 6,
                  resize: "vertical"
                }}
                placeholder="Type comment..."
              />
              <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
                <button
                  onClick={saveComment}
                  style={{
                    flex: 1,
                    background: "#3B82F6",
                    border: "none",
                    color: "#fff",
                    borderRadius: 4,
                    padding: "6px 0",
                    cursor: "pointer"
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setShowAdd(false);
                    setNewComment("");
                  }}
                  style={{
                    flex: 1,
                    background: "#555",
                    border: "none",
                    color: "#fff",
                    borderRadius: 4,
                    padding: "6px 0",
                    cursor: "pointer"
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setShowAdd(true)}
              style={{
                marginTop: 10,
                background: "#6B7280",
                border: "none",
                color: "#fff",
                borderRadius: 4,
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: 14
              }}
            >
              + Add comment
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default TicketBlock;